const appInfo = {
    title: 'innKEP.'
};
export default appInfo;

